import { render, staticRenderFns } from "./SimpleExamModelAdd.vue?vue&type=template&id=f5adfaee&"
import script from "./SimpleExamModelAdd.vue?vue&type=script&lang=js&"
export * from "./SimpleExamModelAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports